import { render, staticRenderFns } from "./WitnessDetails.vue?vue&type=template&id=3bdf2ad4"
import script from "./WitnessDetails.vue?vue&type=script&lang=js"
export * from "./WitnessDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports